module.exports = __webpack_public_path__ + "static/media/FPX_APP.b56e1e19.svg";